import React from 'react';
import { motion, HTMLMotionProps } from 'framer-motion';
import { Loader2 } from 'lucide-react';
interface ButtonProps extends HTMLMotionProps<'button'> {
  variant?: 'primary' | 'secondary' | 'outline';
  isLoading?: boolean;
  fullWidth?: boolean;
}
export function Button({
  children,
  variant = 'primary',
  isLoading,
  fullWidth = false,
  className = '',
  disabled,
  ...props
}: ButtonProps) {
  const baseStyles = 'relative inline-flex items-center justify-center rounded-full px-10 py-5 text-lg font-medium transition-all duration-500 focus:outline-none focus:ring-1 focus:ring-offset-2 disabled:opacity-50 disabled:cursor-not-allowed overflow-hidden tracking-wide';
  const variants = {
    primary: 'gradient-button text-white organic-shadow hover:shadow-xl focus:ring-[#9B87C7]',
    secondary: 'bg-[#F8F8FA] text-[#2D2A35] hover:bg-[#F0F0F2] focus:ring-[#B5A8D4] shadow-sm',
    outline: 'border border-[#E8E4EE] text-[#2D2A35] hover:bg-[#FDFCFE] hover:border-[#B5A8D4] focus:ring-[#B5A8D4]'
  };
  return <motion.button whileHover={{
    scale: disabled ? 1 : 1.02,
    y: disabled ? 0 : -2
  }} whileTap={{
    scale: disabled ? 1 : 0.98,
    y: 0
  }} transition={{
    duration: 0.5,
    ease: [0.25, 0.1, 0.25, 1]
  }} className={`${baseStyles} ${variants[variant]} ${fullWidth ? 'w-full' : ''} ${className}`} disabled={disabled || isLoading} {...props}>
      {isLoading && <Loader2 className="mr-2 h-4 w-4 animate-spin" />}
      <span className="relative z-10 flex items-center justify-center gap-2">
        {children}
      </span>
    </motion.button>;
}